module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/keg3ds/tc-custom/9781467448741.jpg?1744436099203",
      "alt": "This image is the cover for the book Hope and Community"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Hope and Community\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('i', [_vm._v("The culmination of Kärkkäinen's multivolume magnum opus")]), _c('br'), _c('br'), _vm._v(" This fifth and final volume of Veli-Matti Kärkkäinen's ambitious five-volume systematic theology develops a constructive Christian eschatology and ecclesiology in dialogue with the Christian tradition, with contemporary theology in all its global and contextual diversity, and with other major living faiths—Judaism, Islam, Buddhism, and Hinduism."), _c('br'), _c('br'), _vm._v(" In Part One of the book Kärkkäinen discusses eschatology in the contexts of world faiths and natural sciences, including physical, cosmological, and neuroscientific theories. In Part Two, on ecclesiology, he adopts a deeply ecumenical approach. His proposal for greater Christian unity includes the various dimensions of the church's missional existence and a robust dialogical witness to other faith communities.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Veli-Matti Karkkainen\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Veli-Matti Kärkkäinen is professor of systematic theology at Fuller Theological Seminary, Pasadena,California, and docent of ecumenics at the University of Helsinki, Finland.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wm. B. Eerdmans Publishing Co.\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0